import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const PickCoachHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Coach auswählen',
        iconPath: 'icon_coach_homescreen.svg',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={() => navigate('pick-coach')}
            isHidden={false}
            disabled={false}
        />
    );
};
export default PickCoachHomeScreenButton;